import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";



// Add Product
export const AddProduct  = async (name) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: API_URLS.ADMIN + "list-product/create",
            data:  { name },
            headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response);
        return response;
    } catch (error) {
        console.error( error);
        throw error;
    }
}
//ENd

// Get Products
export const fetchProducts  = async (page = 1) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: `${API_URLS.ADMIN}list-product/report?page=${page}`,
            headers: { Authorization: `Bearer ${token}` },
        });
       console.log(response);
        return response;
    } catch (error) {
        console.error( error);
        throw error;
    }
};
// ENd

// Edit Product
export const editProduct  = async ({ product_id }) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: API_URLS.ADMIN + "list-product/edit",
            data: { product_id },
            headers: { Authorization: `Bearer ${token}` },
        });
       // console.log(response);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
// ENd

// Update Product

export const updateProduct  = async ({ payload, product_id }) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: `${API_URLS.ADMIN}list-product/update`,
            data: { product_id, ...payload },
            headers: { Authorization: `Bearer ${token}` },
        });
       // console.log(response);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};


// Retrieve Product
export const retrieveProduct = async (page = 1) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: `${API_URLS.ADMIN}list-product/retrive?page=${page}`,
            headers: { Authorization: `Bearer ${token}` },
        });
       // console.log(response);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export const deleteProduct=async (id)=>{
    try {
        const response = await postRequest({
            url: `${API_URLS.ADMIN}product-news/delete`,
            data:{
                'product_news_id':id
            },
            headers: { Authorization: `Bearer ${getAuthToken()}` },
        }); 
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
// ENd